import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    card: {
        padding: '8px',
        height: '216px',
        marginLeft: '32px',
        width: '300px',
    },
    cardWrapper: {
        alignItems: 'start',
        display: 'flex',
        flexDirection: 'row',
        height: '50%',
        paddingTop: '32px',
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: '2048px',
        width: '100%',
        marginLeft: theme.spacing(8),
    },
}));

export default useStyles;
